export default __webpack_public_path__ + "static/media/3132 spice rack F top.a5f4058e.png";